var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MainLayout',[_c('Hero'),_c('ThreeSteps',{attrs:{"id":"three-steps"}}),_c('LocateLead',{attrs:{"id":"locate-lead"}}),_c('Features',{attrs:{"id":"features"}}),_c('Pricing',{attrs:{"id":"pricing"}}),_c('JoinUs',{attrs:{"id":"join-us"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }